export default __webpack_public_path__ + "static/media/akihiro-kato.c0a38037.png";